module.exports = __webpack_public_path__ + "static/shapya_spinner-a1edafa63c0e02e508fc2f03bc15fd01.gif";